var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ri:youtube-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.3458 5.6665C18.1023 5.67075 19.995 5.68917 22.0067 5.76992L22.7207 5.80109C24.7451 5.896 26.7681 6.06034 27.7725 6.33942C29.1112 6.71625 30.1624 7.81275 30.518 9.20392C31.0847 11.4139 31.1555 15.7234 31.164 16.7675L31.1654 16.9828V17.2293C31.1555 18.2734 31.0847 22.5843 30.518 24.7929C30.1582 26.1883 29.1056 27.2863 27.7725 27.6574C26.7681 27.9365 24.7451 28.1008 22.7207 28.1958L22.0067 28.2283C19.995 28.3077 18.1023 28.3275 17.3458 28.3303L17.0129 28.3318H16.6517C15.0508 28.3218 8.35566 28.2496 6.225 27.6574C4.88766 27.2806 3.83508 26.1841 3.4795 24.7929C2.91283 22.5829 2.842 18.2734 2.8335 17.2293V16.7675C2.842 15.7234 2.91283 11.4125 3.4795 9.20392C3.83933 7.8085 4.89191 6.71059 6.22641 6.34084C8.35566 5.74725 15.0522 5.675 16.6531 5.6665H17.3458ZM14.1654 12.0415V21.9582L22.6654 16.9998L14.1654 12.0415Z",
    fill: "#F04438"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.a4782d01813f292a7aca81d28d8bed5b.svg";
export { ForwardRef as ReactComponent };